import { StatusBar } from 'expo-status-bar';
import {  Image,  StyleSheet, Text, View, ActivityIndicator, SafeAreaView, TouchableOpacity, FlatList, SectionList, Dimensions } from 'react-native';
import React, {useState, useEffect} from 'react';
import { FontAwesome, Ionicons } from '@expo/vector-icons';
import logo from './../assets/logo-psihomaestru-3.png'; 

const { width } = Dimensions.get('window');

export default function Questions({navigation , route}) {
  
  const { tokenKey } = route.params;
  const { PUN_utilizatorID } = route.params;
  const { PUN_U_Status } = route.params;
  const { name } = route.params;
  const { continuewith } = route.params;

  const [isLoading, setLoading] = useState(true);
  const [isImageLoading, setImageLoadStatus] = useState(false);
  const [shouldShowV1, setshouldShowV1] = useState(false);

  let [section, setSection] = useState('');
  let [conditie, setConditie] = useState('4'); //this has to be changed based on the section opened 4 is for first one
  let [intrebare, setAfectiuni] = useState('');
  let [A_denumireID, setA_denumireID] = useState('1');
  let [condSecID, setcondSecID] = useState('');
  //Insert current section not the next in the database
  let [currentsection, setcurrentsection] = useState('');
  const GetAfectiunes = async  (Sec,Raspuns) => {
    try {
      const response = await fetch('https://rupertapi.azurewebsites.net/api/afectiune', {
        method:'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+tokenKey
        },
        body: JSON.stringify(
          {
            "sectiune": Sec
          }
        )
      }
      )
      const json = await response.json();
      console.log();
      setAfectiuni(json[0].intrebari);
      setConditie(json[0].conditie);
      setA_denumireID(json[0].denumireID); // don't take it from Afectiunes couse we need to control it
      setcurrentsection(json[0].sectiuneID);
      setcondSecID(json[0].condSecID);
      if (countDA == conditie && Raspuns == 'DA') {
        setSection(json[0].condSecID);
        setcountDA(1);
      } else {
        setSection(json[0].nextSection);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }



  //Put method to user actions
  let [A_utilizatorID, setA_utilizatorID] = useState('');
  const PutActionUtilizator = async  () => {
    try {
      const response = await fetch('https://rupertapi.azurewebsites.net/api/action', {
        method:'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+tokenKey
        },
        body: JSON.stringify(
          {
            "UtilizatorID": PUN_utilizatorID,
            "AfectiuniSectiune": currentsection,
            "DataInregistrarii": currentDate
          }
        )
      }
      )
      const json = await response.json();
      console.log(json);
      setA_utilizatorID(json.utilizatorID);
      setA_denumireID(json.denumireID);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  let [countDA, setcountDA] = useState(1);
  const GetCountDA = () => {
    setcountDA(countDA+1)
  };
  
  
  const get_image_url = (currentsection) => {
    return  `https://rupertblob.blob.core.windows.net/rupertbotqpic/${currentsection}.png`;
  }

  const SECTIONS = [
    {
      title: 'Made for you',
      horizontal: false,
      data: [
        {
          key: '1',
          text: 'Am stari de frica intensa, anxietate.',
          uri: 'https://rupertblob.blob.core.windows.net/rupertbotqpic/F1.png',
          problem: 'F1',
        },
        {
          key: '2',
          text: 'Am stări de tristețe accentuată, lipsă de energie, gânduri negative.',
          uri: 'https://rupertblob.blob.core.windows.net/rupertbotqpic/A1.png',
          problem: 'A1',
        },
  
        {
          key: '3',
          text: 'Am o dependență, un viciu',
          uri: 'https://rupertblob.blob.core.windows.net/rupertbotqpic/E1.png',
          problem: 'E1',
        },
        {
          key: '4',
          text: 'Am probleme de alimentație, probleme cu greutatea',
          uri: 'https://rupertblob.blob.core.windows.net/rupertbotqpic/B1.png',
          problem: 'B1',
        },
        // {
        //   key: '5',
        //   text: 'Am stări de agitație, furie, probleme de comportament',
        //   uri: 'https://rupertblob.blob.core.windows.net/rupertbotqpic/F13.png',
        //   problem: 'G1',
        // },
      ],
    },
  ];
  
  const ListItem = ({ item }) => {
    
    return (
      <View style={styles.item}>
        <View style={styles.TextContainer}>
          <View style={styles.TextRow}>
            <Text style={styles.textCenter}>{item.text}</Text>
          </View>
        </View>
        <Image
          source={{
            uri: item.uri,
          }}
          style={styles.itemPhoto}
          resizeMode="cover"
        />

        <TouchableOpacity
              style={styles.buttonPlay}
                onPress=
                { 
                  () => {
                  // setSection(item.problem);
                  GetAfectiunes(item.problem);
                  setshouldShowV1(false);
                  }
                }
              >
                <Ionicons name="ios-play" size={24} color="#628914" />
          </TouchableOpacity>
      </View>
    );
  };
  


  const [currentDate, setCurrentDate] = useState('');
  useEffect(() => {

    var date = new Date().getDate(); //Current Date
    var month = new Date().getMonth() + 1; //Current Month
    var year = new Date().getFullYear(); //Current Year
    var hours = new Date().getHours(); //Current Hours
    var min = new Date().getMinutes(); //Current Minutes
    var sec = new Date().getSeconds(); //Current Seconds
    setCurrentDate(
      year + '-' + month  + '-' + date + ' ' + hours + ':' + min + ':' + sec
    );
    setLoading(true);
    setshouldShowV1(true);
    if (continuewith) {
      GetAfectiunes(continuewith);
      setshouldShowV1(false);
      return;
    }
  }, []);

  // console.log('token: '+tokenKey);
  // console.log('U_status: '+ PUN_U_Status)
  // console.log('utilizatorID:'+PUN_utilizatorID);

  // console.log('intrebare: '+intrebare);
  // // console.log('JsonLengthCount: '+JsonLengthCount);
  // console.log('conditie: '+conditie);
  // console.log('section: '+section);
  // console.log('currentsection: '+currentsection);
  // console.log('A_denumireID:'+A_denumireID); 

  // // console.log('currentcount:'+currentcount); 
  // console.log('countDA: '+countDA);
  // console.log('condSecID: '+condSecID);


  return (
    <View style={[{ 
      // minHeight: Math.round(windowHeight),
      flex: 1,
      backgroundColor: '#fff'
      }]}>
      {/* {shouldShowV1 ? (
      <Image source={logo} style={styles.logo} />
      ) : null}  */}
      {shouldShowV1 ? (
      <Text style={styles.h1}>Salut {name}.</Text> 
      ) : null}
      {shouldShowV1 ? (
      <Text style={styles.MainText}>Care este problema cea mai importantă cu care te confrunți?</Text>
      ) : null}


      {shouldShowV1 ? (
      <SafeAreaView style={{ flex: 1, top: 30 }}>
        <SectionList
          contentContainerStyle={{ paddingHorizontal: 10}}
          stickySectionHeadersEnabled={false}
          sections={SECTIONS}
          renderSectionHeader={({ section }) => (
            <>
              {/* <Text style={styles.sectionHeader}>{section.title}</Text> */}
              {section.horizontal ? (
                <FlatList
                  horizontal
                  data={section.data}
                  renderItem={({ item }) => <ListItem item={item} />}
                  showsHorizontalScrollIndicator={false}
                />
              ) : null}
            </>
          )}
          renderItem={({ item, section }) => {
            if (section.horizontal) {
              return null;
            }
            return <ListItem item={item} />;
          }}
        />
      </SafeAreaView>
      ) : null}  

      {isLoading ? 
        ( 
          null // <ActivityIndicator size="large" color="#628914" style={{top: -10, alignSelf: 'center', zIndex: 1, elevation: 1 }} />
        ) : (
      <View style={styles.Swipes}>
            <View style={styles.TextContainer}>
              <View style={styles.TextRow}>
                <Text style={styles.textCenter}>{intrebare}</Text>
              </View>
            </View>
            <Image
              style={styles.photo}
              source={{uri:get_image_url(currentsection)}}
              onLoadEnd={() => setImageLoadStatus(true)} 
            />
            <ActivityIndicator size="large" color="#404A3C" animating={!isImageLoading} style={{ position: "absolute", top: 350, alignSelf: 'center', zIndex: 1, elevation: 1 }} />

      </View>
        )
      }

      {isLoading ? 
        ( 
          null
        ) : (
      <View style={styles.BottomContainer}>
        {/* {AICI E NUUUU} */}
        <TouchableOpacity style={styles.button}
          onPress=
          { () => {
              setLoading(true);
              setImageLoadStatus(false);
          //SPECIAL RULES:    
              //NU -> F23 
              if(
                currentsection == 'F1' || 
                currentsection == 'F14' ||
                currentsection == 'F16' || 
                currentsection == 'F17' || 
                currentsection == 'F18') 
              {
                GetAfectiunes('F23-1');
                setcountDA(1);
                return;
              }

              //F23 NU -> F32
              if(
                currentsection == 'F23-1' || 
                currentsection == 'F23-2' || 
                currentsection == 'F23-3' || 
                currentsection == 'F23-4' || 
                currentsection == 'F23-5') 
              if (countDA == conditie) {
                GetAfectiunes(section); //go to next if no
              } else {
                GetAfectiunes('F32');
                setcountDA(1);
                return;
              }
              //F24 - F30 NU -> F32
              if(
                currentsection == 'F24' || 
                currentsection == 'F25' || 
                currentsection == 'F26' || 
                currentsection == 'F27' || 
                currentsection == 'F28'|| 
                currentsection == 'F29' || 
                currentsection == 'F30') 
              {
                GetAfectiunes('F32');
                setcountDA(1);
                return;
              }
              //F32 - F38 NU -> F42
              if(
                currentsection == 'F32' || 
                currentsection == 'F33' || 
                currentsection == 'F34' || 
                currentsection == 'F35' || 
                currentsection == 'F36' || 
                currentsection == 'F37' || 
                currentsection == 'F38' ) 
              {
                GetAfectiunes('F42');
                setcountDA(1);//reseteaza counter de raspunsuri DA
                return;
              }
              //F42,F43 si F50 NU -> G1 (Cel putin 3 raspunsuri de DA pentru intrebarile F44-F50, vor duce la F52, altfel -> G1) =>
              //asta inseamna ca F44 pana la F49 daca raspunde NU merge la urmatoarea conform algoritmului, abia la F50 daca e nu plecam
              //spre G1 pentru ca inseamna ca nu au fost suficienti DA ca sa mearga la F52. F52 nu se duce pe G1.
              if(
                currentsection == 'F42' || 
                currentsection == 'F43' ||
                currentsection == 'F50' ||
                currentsection == 'F52'
                ) 
              {
                GetAfectiunes('G1');
                setcountDA(1);//reseteaza counter de raspunsuri DA
                return;
              }
              //G1 - G2  NU -> G3
              if(
                currentsection == 'G1' || 
                currentsection == 'G2' ) 
              {
                GetAfectiunes('G3');
                setcountDA(1);//reseteaza counter de raspunsuri DA
                return;
              }

              //G3 - G6  NU -> G9
              if(
                currentsection == 'G3' || 
                currentsection == 'G4' || 
                currentsection == 'G6'  ) 
              {
                GetAfectiunes('G9');
                setcountDA(1);//reseteaza counter de raspunsuri DA
                return;
              }

              //G9  NU -> G10
              if(
                currentsection == 'G9') 
              {
                GetAfectiunes('G10');
                setcountDA(1);//reseteaza counter de raspunsuri DA
                return;
              }
              //A1, A2  NU -> A3
              if(
                currentsection == 'A2') 
              {
                GetAfectiunes('A3');
                setcountDA(1);//reseteaza counter de raspunsuri DA
                return;
              }
              //E1  NU -> A29
              if(
                currentsection == 'A11') 
              {
                GetAfectiunes('A29');
                setcountDA(1);//reseteaza counter de raspunsuri DA
                return;
              }
              //E1  NU -> E15
              if(
                currentsection == 'E1') 
              {
                GetAfectiunes('E15');
                setcountDA(1);//reseteaza counter de raspunsuri DA
                return;
              }
              //E12  NU -> E15
              if(
                currentsection == 'E12') 
              {
                GetAfectiunes('E15');
                setcountDA(1);//reseteaza counter de raspunsuri DA
                return;
              }
              //E34  NU -> E35
              if(
                currentsection == 'E34') 
              {
                GetAfectiunes('E35');
                setcountDA(1);//reseteaza counter de raspunsuri DA
                return;
              }
              //E40  NU -> E41
              if(
                currentsection == 'E40') 
              {
                GetAfectiunes('E41');
                setcountDA(1);//reseteaza counter de raspunsuri DA
                return;
              }
              //E41  NU -> E48
              if(
                currentsection == 'E41') 
              {
                GetAfectiunes('E48');
                setcountDA(1);//reseteaza counter de raspunsuri DA
                return;
              }
              //E47  NU -> E48
              if(
                currentsection == 'E47') 
              {
                GetAfectiunes('E48');
                setcountDA(1);//reseteaza counter de raspunsuri DA
                return;
              }
              //E55  NU -> E56
              if(
                currentsection == 'E55') 
              {
                GetAfectiunes('E56');
                setcountDA(1);//reseteaza counter de raspunsuri DA
                return;
              }
              //B1 NU -> B9 
              if(
                currentsection == 'B1') 
              {
                GetAfectiunes('B9');
                setcountDA(1);
                return;
              }
              //B6 NU -> B36
              if(
                currentsection == 'B6') 
              {
                GetAfectiunes('B36');
                setcountDA(1);
                return;
              }
              //B8  NU -> B36
              if(
                currentsection == 'B8') 
              {
                GetAfectiunes('B19');
                setcountDA(1);
                return;
              }
              //B9  NU -> B19
              if(
                currentsection == 'B9') 
              {
                GetAfectiunes('B19');
                setcountDA(1);
                return;
              }
              //B18  NU -> B19
              if(
                currentsection == 'B18') 
              {
                GetAfectiunes('B19');
                setcountDA(1);
                return;
              }
              //B19  NU -> B27
              if(
                currentsection == 'B19') 
              {
                GetAfectiunes('B27');
                setcountDA(1);
                return;
              }
              //B26  NU -> B27
              if(
                currentsection == 'B26') 
              {
                GetAfectiunes('B27');
                setcountDA(1);
                return;
              }
              //B27  NU -> B36
              if(
                currentsection == 'B27') 
              {
                GetAfectiunes('B36');
                setcountDA(1);
                return;
              }
              //B35  NU -> B36
              if(
                currentsection == 'B35') 
              {
                GetAfectiunes('B36');
                setcountDA(1);
                return;
              }
          //DIAGNOSTICE STABILITE:  
              //D2 - Tulburarea de panică - Catre diagnostic cand raspunsul de NU trebuie sa duca acolo
              if(
                currentsection == 'F20' || 
                currentsection == 'F32') {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburarea de panica', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: 'D2',
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Tulburarea de panică', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: 'D2',
                  }); //sending diagnostic variable
                return;
              }

              //D5 - Tulburare anxioasă socială - Catre diagnostic cand raspunsul de NU trebuie sa duca acolo
              if(
                currentsection == 'F39') {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburare anxioasă socială', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: 'D5',  
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                    {name:name, 
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburare anxioasă socială', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: 'D5',  
                    }); //sending diagnostic variable
                return;
              }
              //D81 - Alte tulburări anxioase - Catre diagnostic cand raspunsul de NU trebuie sa duca acolo
              if(
                currentsection == 'G10' ||
                currentsection == 'G32' 
                ) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Alte tulburări anxioase', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: 'D81', 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                    {name:name, 
                      tokenKey:tokenKey, 
                      Diagnostic:'Alte tulburări anxioase', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: 'D81', 
                    }); //sending diagnostic variable
                return;
              }

              //A12 - Episod depresiv major D121 - Catre diagnostic cand raspunsul de NU trebuie sa duca acolo
              if(
                currentsection == 'A12'
                ) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Episod depresiv major', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: 'D121',  
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                    {name:name, 
                      tokenKey:tokenKey, 
                      Diagnostic:'Episod depresiv major', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: 'D121',  
                    }); //sending diagnostic variable
                return;
              }

              //A37 raspuns NU => D12 = Alte tulburari depresive
              if(currentsection == 'A37' && countDA < conditie) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Alte tulburari depresive', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: 'D12', 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Alte tulburari depresive', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: 'D12', 
                  }); //sending diagnostic variable
                return;
              }

              //A38 - Episod maniacal  D111 - Catre diagnostic cand raspunsul de NU trebuie sa duca acolo
              if(
                currentsection == 'A38'
                ) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Episod maniacal', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: 'D111', 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                    {name:name, 
                      tokenKey:tokenKey, 
                      Diagnostic:'Episod maniacal', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: 'D111', 
                    }); //sending diagnostic variable
                return;
              }
              //D19 - Alte tipuri de dependențe  - Catre diagnostic cand raspunsul de NU trebuie sa duca acolo
              if(
                section == 'D19'
                ) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Alte tipuri de dependențe', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: 'D19', 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                    {name:name, 
                      tokenKey:tokenKey, 
                      Diagnostic:'Alte tipuri de dependențe', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: 'D19', 
                    }); //sending diagnostic variable
                return;
              }
              //D25 - AAlte tulburari alimentare  - Catre diagnostic cand raspunsul de NU trebuie sa duca acolo
              if(
                section == 'D25'
                ) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Alte tulburări alimentare', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: 'D25', 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                    {name:name, 
                      tokenKey:tokenKey, 
                      Diagnostic:'Alte tulburări alimentare', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: 'D25', 
                    }); //sending diagnostic variable
                return;
              }


          //Continuarea actiunilor pe NU:
              setshouldShowV1(false);
              GetAfectiunes(section,'NU');
            }
          }
        >
          <FontAwesome name="times" size={27} color="#F06795"></FontAwesome>
        </TouchableOpacity>
        {/* {AICI E DAAAAA} */}
        <TouchableOpacity style={styles.button}
          onPress=
          { 
            () => {
              setLoading(true);
              setImageLoadStatus(false);
        //SPECIAL RULES:  
              if(currentsection == 'F43') {
                  setcountDA(1); //resetare counter la 1 ca sa putem sa indeplinim conditia mai jos.
                  GetAfectiunes(section, 'DA');
                  return;
              }
              if(currentsection == 'G10') {
                  setcountDA(1); //resetare counter la 1 ca sa putem sa indeplinim conditia mai jos.
                  GetAfectiunes(section, 'DA');
                  return;
              }
              if(currentsection == 'E1') {
                setcountDA(1); //resetare counter la 1 ca sa putem sa indeplinim conditia mai jos.
                GetAfectiunes(section, 'DA');
                return;
              }
              if(currentsection == 'E15') {
                setcountDA(1); //resetare counter la 1 ca sa putem sa indeplinim conditia mai jos.
                GetAfectiunes(section, 'DA');
                return;
              }
              if(currentsection == 'E22') {
                setcountDA(1); //resetare counter la 1 ca sa putem sa indeplinim conditia mai jos.
                GetAfectiunes(section, 'DA');
                return;
              }
              if(currentsection == 'B8' && countDA != conditie) {
                setcountDA(1); //resetare counter la 1 ca sa putem sa indeplinim conditia mai jos.
                GetAfectiunes(section, 'DA');
                return;
              }
              if(currentsection == 'B18' && countDA != conditie) {
                setcountDA(1); //resetare counter la 1 ca sa putem sa indeplinim conditia mai jos.
                GetAfectiunes(section, 'DA');
                return;
              }
              if(currentsection == 'B26' && countDA != conditie) {
                setcountDA(1); //resetare counter la 1 ca sa putem sa indeplinim conditia mai jos.
                GetAfectiunes(section, 'DA');
                return;
              }
              if(currentsection == 'B35' && countDA != conditie) {
                setcountDA(1); //resetare counter la 1 ca sa putem sa indeplinim conditia mai jos.
                GetAfectiunes(section, 'DA');
                return;
              }
              if(currentsection == 'B45' && countDA != conditie) {
                setcountDA(1); //resetare counter la 1 ca sa putem sa indeplinim conditia mai jos.
                GetAfectiunes(section, 'DA');
                return;
              }
        //CONTINUARE ACTIUNILOR PE DA:  
              GetCountDA();
            //CONDITIE SPECIALA:       
              if (countDA == conditie) {
                GetAfectiunes(condSecID);//use condition section for next
              } else {
                GetAfectiunes(section, 'DA');
              }
              PutActionUtilizator();
               
        //DIAGNOSTICE STABILITE goto Diagnostic Page: 
              //D1 = Tulburare anxioasă secundară unei afecțiuni sau Tulburare anxioasă indusă de substanţe
              if(condSecID == 'D1') {
                //Adding the Diagnostic in ACTIONS so it can be displayed in account for user
                //now navigation
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburare anxioasă secundară', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: condSecID,
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                    {
                      name:name, 
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburare anxioasă secundară', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: condSecID,
                    }); //sending diagnostic variable
                return;
              }
              //second Tulburare anxioasa secundara from F39 same as D1 but is D1111
              if(condSecID == 'D1111') {
                //Adding the Diagnostic in ACTIONS so it can be displayed in account for user
                //now navigation
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburare anxioasă secundară', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: condSecID,
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                    {
                      name:name, 
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburare anxioasă secundară', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: condSecID,
                    }); //sending diagnostic variable
                return;
              }
              //D2 = Tulburarea de panică
              if(condSecID == 'D2') {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburarea de panică', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: condSecID, 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Tulburarea de panică', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID, 
                  }); //sending diagnostic variable
                return;
              }
              //D3 = Agorafobie
              if(condSecID == 'D3') {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Agorafobie', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: condSecID, 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Agorafobie', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID, 
                  }); //sending diagnostic variable
                return;
              }
              //D6 = Tulburare anxioasă generalizată
              if(condSecID == 'D6') {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburare anxioasă generalizată', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: condSecID, 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Tulburare anxioasă generalizată', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID, 
                  }); //sending diagnostic variable
                return;
              }

              //D7 = Tulburarea obsesiv-compulsivă
              if(condSecID == 'D7') {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburarea obsesiv-compulsivă', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: condSecID,  
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Tulburarea obsesiv-compulsivă', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID, 
                  }); //sending diagnostic variable
                return;
              }

              //D8 = Tulburarea de stres posttraumatic
              if(condSecID == 'D8' && countDA == conditie) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburarea de stres posttraumatic', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: condSecID,  
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Tulburarea de stres posttraumatic', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID, 
                  }); //sending diagnostic variable
                return;
              }

              //A37 raspuns DA D12 = Alte tulburari depresive
              if(currentsection == 'A37' && countDA < conditie) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Alte tulburari depresive', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: condSecID,  
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Alte tulburari depresive', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID, 
                  }); //sending diagnostic variable
                return;
              }


              //D11 = Tulburare maniacală indusă de medicamente sau Tulburare maniacală secundară unei afecțiuni 
              if(condSecID == 'D11') {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburare maniacală indusă de medicamente', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: condSecID, 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Tulburare maniacală indusă de medicamente', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID, 
                  }); //sending diagnostic variable
                return;
              }

              //D13 = Tulburare a consumului de alcool 
              if(condSecID == 'D13' && countDA == conditie) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburare a consumului de alcool', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: condSecID,  
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Tulburare a consumului de alcool', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID, 
                  }); //sending diagnostic variable
                return;
              }

              //D14 = Tulburarea consumului de substanţe nealcoolice 
              if(condSecID == 'D14' && countDA == conditie) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburarea consumului de substanţe nealcoolice', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: condSecID, 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Tulburarea consumului de substanţe nealcoolice', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID, 
                  }); //sending diagnostic variable
                return;
              }

              //D15 = Dependența de fumat 
              if(condSecID == 'D15' && countDA == conditie) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Dependența de fumat', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: condSecID, 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Dependența de fumat', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID, 
                  }); //sending diagnostic variable
                return;
              }

              //D16 = Dependența de jocuri și rețele sociale
              if(condSecID == 'D16' && countDA == conditie) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Dependența de jocuri și rețele sociale', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: condSecID, 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Dependența de jocuri și rețele sociale', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID, 
                  }); //sending diagnostic variable
                return;
              }
              
              //D17 = Dependența de pornografie
              if(condSecID == 'D17' && countDA == conditie) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Dependența de pornografie', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: condSecID, 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Dependența de pornografie', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID, 
                  }); //sending diagnostic variable
                return;
              }

              //D18 - Dependența de cumpărături 
              if(
                (currentsection == 'E64' && countDA == conditie) || 
                (condSecID == 'D18' && countDA == conditie)
                ) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Dependența de cumpărături', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: condSecID, 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                    {name:name, 
                      tokenKey:tokenKey, 
                      Diagnostic:'Dependența de cumpărături', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: condSecID, 
                    }); //sending diagnostic variable
                return;
              }

              //D19 - Alte tipuri de dependențe 
              if(
                currentsection == 'E64' && 
                countDA != conditie
                ) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Alte tipuri de dependențe', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: condSecID, 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                    {name:name, 
                      tokenKey:tokenKey, 
                      Diagnostic:'Alte tipuri de dependențe', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: condSecID, 
                    }); //sending diagnostic variable
                return;
              }

              //D20 = Bulimie
              if(condSecID == 'D20' && countDA == conditie) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Bulimie', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: condSecID,
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Bulimie', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID,
                  }); //sending diagnostic variable
                return;
              }

              //D21 = Anorexie
              if(condSecID == 'D21' && countDA == conditie) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Anorexie', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: condSecID,
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Anorexie', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID,
                  }); //sending diagnostic variable
                return;
              }

              //D22 = Tulburarea dismorfică corporală 
              if(condSecID == 'D22' && countDA == conditie) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburarea dismorfică corporală', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: condSecID,
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Tulburarea dismorfică corporală', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID,
                  }); //sending diagnostic variable
                return;
              }
              //D23 = Ortorexia nervoasă
              if(condSecID == 'D23' && countDA == conditie) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Ortorexia nervoasă', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: condSecID,
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Ortorexia nervoasă', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID,
                  }); //sending diagnostic variable
                return;
              }
              //D24 = Mâncatul compulsiv
              if(condSecID == 'D24' && countDA == conditie) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Mâncatul compulsiv', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: condSecID,
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Mâncatul compulsiv', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID,
                  }); //sending diagnostic variable
                return;
              }
              //D25 - Alte tulburari alimentare  - Catre diagnostic cand raspunsul de NU trebuie sa duca acolo
              if(
                section == 'D25'
                ) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Alte tulburari alimentare', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: 'D25', 
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                    {name:name, 
                      tokenKey:tokenKey, 
                      Diagnostic:'Alte tulburari alimentare', 
                      PUN_utilizatorID:PUN_utilizatorID,
                      currentDate: currentDate,
                      sectiune: 'D25', 
                    }); //sending diagnostic variable
                return;
              }
              //D26 = Mâncatul compulsiv
              if(condSecID == 'D26' && countDA == conditie) {
                if (PUN_U_Status == 2) {
                  navigation.replace('Diagnostic',
                    {
                      tokenKey:tokenKey, 
                      Diagnostic:'Tulburare depresivă indusă de medicamente sau Tulburare depresivă secundară unei afecțiuni', 
                      PUN_utilizatorID:PUN_utilizatorID, 
                      currentDate: currentDate,
                      sectiune: condSecID,
                    });
                    return;
                }
                navigation.replace('Evaluare Nouă', 
                  {   
                    name:name, 
                    tokenKey:tokenKey, 
                    Diagnostic:'Tulburare depresivă indusă de medicamente sau Tulburare depresivă secundară unei afecțiuni', 
                    PUN_utilizatorID:PUN_utilizatorID,
                    currentDate: currentDate,
                    sectiune: condSecID,
                  }); //sending diagnostic variable
                return;
              }


              setshouldShowV1(false);
              }
          }
        >
          <FontAwesome name="check" size={27} color="#628914"></FontAwesome>
        </TouchableOpacity>
      </View>
        )
      }
      <StatusBar style="auto" />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    top: 5,
    left: 20,
    width: 150, 
    height: 35,
  },
  h1: {
    fontSize: 16,
    alignContent: "flex-start",
    fontWeight: 'bold',
    top: 20,
    left: 20,
    color:"#628914",
  },
  MainText: {
    fontSize: 14,
    alignContent: "flex-start",
    color: "#3E473A",
    flexShrink: 1,
    top: 20,
    left: 20,
    right:2,
  },
  panel: {
    paddingTop: 20,
    shadowColor: '#000',
    width:'100%',
    top: 40,
  },
  panelbgr: {
    height: 60,
    borderRadius: 20,
    backgroundColor: '#CCD8A6',
    padding:10,
  },
  buttonPlay: {
    position: 'absolute',
    top:100,
    alignSelf: 'center',
    width: 50,
    height: 50,
    backgroundColor: '#EFEB88',
    borderRadius:25,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    shadowOpacity: 0.15,
    shadowRadius:6.46,
    elevation:9,
    zIndex: 9,
  },
  image: {
    width: 400,
    height: 200,
    margin: 5,
    resizeMode: 'contain',
  },

  Swipes: {
    flex: 1,
    padding:10,
    paddingTop: 8,
    shadowColor: '#000',
  },
  photo: {
    height: '95%',
    resizeMode: 'cover',
    borderRadius: 20,
    backgroundColor: '#364E32',
    top:20,
    bottom:30
  },
  TextContainer: {
    // position: 'absolute',
    alignContent: 'center',
    // top: 20,
    left: 5,
    right: 15
  },
  TextRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
textCenter: {
    fontSize: 35,
    fontWeight: 'bold',
    color: "#364E32",
    fontSize: 18,
    
  },
textShadow: {
    fontSize: 20,
    fontWeight: 'bold',
    color: "#364E32",
    textShadowColor: 'rgba(0, 0, 0, 0.80)',
    textShadowOffset: {
      width: -1,
      height: 1,
    },
    textShadowRadius: 1,
  },
  BottomContainer:{
    height:75,
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  button: {
    width: 50,
    height: 50,
    backgroundColor: '#EFEB88',
    borderRadius:25,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    shadowOpacity: 0.15,
    shadowRadius:6.46,
    elevation:9,
  },
  sectionHeader: {
    fontWeight: '800',
    fontSize: 18,
    color: 'black',
    marginTop: 20,
    marginBottom: 5,
  },
  item: {
    margin: 10,
    right:20,
  },
  itemPhoto: {
    borderRadius:10,
    width: width * 0.9,
    height: width * 0.5,
    left:20,
  },
  itemText: {
    color: 'black',
    marginTop: 5,
  },

});

